import React from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import "./styles.css";
import { Link } from "react-router-dom";

export const CarouselTopProducts: React.FC = () => {
  return (
    <Carousel showArrows={true} className="main-slide">
      <div className="FotoCarousel1">
        <div className="colorTranseparenciBackground">
          <div className="product">
            <div className="divImg">
              <img
                className="imgProduct"
                src="https://res.cloudinary.com/ddoltb8nf/image/upload/v1662085729/just/711zqkSe8oL._AC_SL1500_-removebg-preview_kgqq36.png"
              />
            </div>
            <div className="textProduct">
              <h1>B-NOX ANDRORUSH</h1>
              <h2>LO QUE NECESITAS PARA TU ENTRENAMIENTO</h2>
              <Link to="#">VER PRODUCTO</Link>
            </div>
          </div>
          <h1 className="titleCarousel">NO PAIN NO GAIN</h1>
        </div>
      </div>
      <div className="FotoCarousel2">
        <div className="colorTranseparenciBackground">
          <div className="divImg2">
            <img
              className="imgProduct2"
              src="https://res.cloudinary.com/ddoltb8nf/image/upload/v1662085729/just/711zqkSe8oL._AC_SL1500_-removebg-preview_kgqq36.png"
            />
          </div>
          <h1>B-NOX ANDRORUSH</h1>
          <h2>LO QUE NECESITAS PARA TU ENTRENAMIENTO</h2>
          <Link to="#">VER PRODUCTO</Link>
        </div>
      </div>
      <div className="FotoCarousel3">
        <div className="colorTranseparenciBackground">
          <div className="divImg2">
            <img
              className="imgProduct2"
              src="https://res.cloudinary.com/ddoltb8nf/image/upload/v1662085729/just/711zqkSe8oL._AC_SL1500_-removebg-preview_kgqq36.png"
            />
          </div>
          <h1>B-NOX ANDRORUSH</h1>
          <h2>LO QUE NECESITAS PARA TU ENTRENAMIENTO</h2>
          <Link to="#">VER PRODUCTO</Link>
        </div>
      </div>
    </Carousel>
  );
};
export default CarouselTopProducts;
